<div class="flex flex-col justify-center items-center pt-[100px] z-10">
    <div class="font-outfit text-3xl font-semibold mb-6">
        our process
    </div>
    <div class="px-4 sm:px-[22%] text-justify sm:text-center text-sm sm:text-base relative z-10">
        The SEM Nexus App Marketing Process uses a combination of app store optimization or ASO, App Store & Play Store
        ads, and social media ads. We also utilize <span class="gradient-text">influencers</span> to acquire users,
        followed by in-app analytics to retain
        active and paying users. In order to guarantee the best launch or campaign possible for your app we adhere to
        the following <span class="gradient-text">4 phase process:</span>
    </div>
    <div class="mt-[100px] w-[95%] flex flex-col sm:items-center">
        <div
            class="flex items-center justify-center sm:space-between flex-col sm:flex-row w-full sm:w-[600px] sm:h-[252px]">
            <div class="flex items-center justify-center w-full sm:w-[191px]">
                <img class="w-[191px]" src="/images/shared/steps/01.png" alt="">
            </div>
            <div class="flex flex-col my-4 sm:my-0 sm:pl-[80px] justify-center w-full">
                <div class="font-outfit text-2xl font-semibold mb-2 text-center sm:text-left">
                    app store optimization
                </div>
                <div class="font-inter text-sm sm:text-base text-center sm:text-left">
                    We start ASO with in-depth keyword research, then craft strategic store descriptions and
                    eye-catching app visuals.
                </div>
            </div>
        </div>
        <div
            class="flex items-center justify-center sm:space-between flex-col sm:flex-row w-full sm:w-[600px] sm:h-[252px]">
            <div class="flex flex-col my-4 sm:my-0 sm:pr-[80px] justify-center w-full order-2 sm:order-1">
                <div class="font-outfit text-2xl font-semibold mb-2 text-center sm:text-left">
                    influencer marketing
                </div>
                <div class="font-inter text-sm sm:text-base text-center sm:text-left">
                    We use top Instagram and TikTok influencers to creatively promote and link to your app, maximizing
                    reach and impact.
                </div>
            </div>
            <div class="flex items-center justify-center w-full sm:w-[191px] order-1 sm:order-2">
                <img class="w-[191px]" src="/images/shared/steps/02.png" alt="">
            </div>
        </div>
        <div
            class="flex items-center justify-center sm:space-between flex-col sm:flex-row w-full sm:w-[600px] sm:h-[252px]">
            <div class="flex items-center justify-center w-full sm:w-[191px]">
                <img class="w-[191px]" src="/images/shared/steps/03.png" alt="">
            </div>
            <div class="flex flex-col my-4 sm:my-0 sm:pl-[80px] justify-center w-full">
                <div class="font-outfit text-2xl font-semibold mb-2 text-center sm:text-left">
                    add marketing
                </div>
                <div class="font-inter text-sm sm:text-base text-center sm:text-left">
                    We run targeted ads on Google, Apple, and social media to scale campaigns and keep your Cost Per
                    Install (CPI) low.
                </div>
            </div>
        </div>
        <div
            class="flex items-center justify-center sm:space-between flex-col sm:flex-row w-full sm:w-[600px] sm:h-[252px]">
            <div class="flex flex-col my-4 sm:my-0 sm:pr-[80px] justify-center w-full order-2 sm:order-1">
                <div class="font-outfit text-2xl font-semibold mb-2 text-center sm:text-left">
                    vc preparation
                </div>
                <div class="font-inter text-sm sm:text-base text-center sm:text-left">
                    Once product-market fit is clear, we create a standout pitch deck and share it with our VC network
                    to help secure funding.
                </div>
            </div>
            <div class="flex items-center justify-center w-full sm:w-[191px] order-1 sm:order-2">
                <img class="w-[191px]" src="/images/shared/steps/04.png" alt="">
            </div>
        </div>
    </div>
</div>